import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import {
  ApplicationContext,
  ApplicationHelpers,
  configureYup,
  initI18n
} from '@invision/core';
import {
  MuiThemeProvider,
  CustomerCareTheme,
  ToastProvider,
  AppErrorBoundary,
  GlobalStyle
} from '@invision/ui';
import { App } from './app/app';
import { store } from './redux/store';

// Initialize validation, internationalization, and API configuration
configureYup();
initI18n();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <ApplicationContext.Provider
    value={ApplicationHelpers.allApplications.Security}
  >
    <Provider store={store}>
      <MuiThemeProvider theme={CustomerCareTheme}>
        <ToastProvider>
          <AppErrorBoundary>
            <GlobalStyle />
            <App />
          </AppErrorBoundary>
        </ToastProvider>
      </MuiThemeProvider>
    </Provider>
  </ApplicationContext.Provider>
);
